module.exports = __webpack_public_path__ + "static/b448ff9f.optimizerBanner.png";